import { Component } from '@theme/component';

/**
 * Dispatch and delivery wording worked out in Liquid goes stale once the cut-off or midnight passes,
 * and Shopify can serve a cached page after that. The server renders the wording for after that moment
 * into a child <template> with the moment in `data-valid-until` (Unix seconds); this swaps it in on time.
 */
class DispatchText extends Component {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('pageshow', this.#check);
    this.#check();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('pageshow', this.#check);
    clearTimeout(this.#timer);
  }

  #check = () => {
    clearTimeout(this.#timer);
    const validUntil = Number(this.dataset.validUntil) * 1000;
    if (!validUntil) return;

    const remaining = validUntil - Date.now();
    if (remaining <= 0) {
      const next = this.querySelector(':scope > template');
      if (next instanceof HTMLTemplateElement) this.replaceChildren(next.content.cloneNode(true));
      delete this.dataset.validUntil;
      return;
    }
    // setTimeout overflows past ~24.8 days; check again then.
    this.#timer = window.setTimeout(this.#check, Math.min(remaining, 2 ** 31 - 1));
  };
}

if (!customElements.get('dispatch-text')) {
  customElements.define('dispatch-text', DispatchText);
}
